<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter" :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button variant="secondary"
              @click="addSSH"
              :disabled="!canAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.security.add_ssh')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-tabs v-model="tabName" nav-class="d-none">
          <b-tab :title="$t('common.security.ssh')">
            <security-ssh-list typeList="ca" :key="refreshKey" :spinnerActivated="activateSpinner" v-model="tabValue"></security-ssh-list>
          </b-tab>
        </b-tabs>
      </div>
    </template>
  </page-outline>
</template>

<script>
import SecuritySSHList from '@/pages/security/SecuritySSHList.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from "@/helpers/routing";

export default {
  name: 'SecuritySSHPage',
  components: {
    'page-outline': PageOutline,
    'security-ssh-list': SecuritySSHList
  },
  props: {
    role: {
      type: String,
      default: '0'
    }
  },
  computed: {
  },
  watch: {
    tabName (val) {
      this.$engine.firstOn().security.currentTab = val
    }
  },
  data () {
    return {
      activateSpinner: false,
      listTitle: '',
      refreshState: false,
      refreshKey: false,
      tabName: 0,
      tabValue: 0,
      canAdd: false
    }
  },
  created () {
    this.tabName = this.role === '1' ? 1 : 0
    this.listTitle = this.$i18n.t('common.security.title')
    // if (this.id !== '-1') {
    //   this.tabName = parseInt(this.id)
    // }
    this.canAdd = true
  },
  methods: {
    onRefresh () {
      this.refreshKey = !this.refreshKey
    },
    addSSH () {
      let that = this
      loadPage(that, {url: '/security/ssh/form/-1'})
    }
  }
}
</script>
